import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { saveAs } from 'file-saver';
import { toQueryParams } from 'helpers/api';
import { createBaseQuery } from 'helpers/api';
import { stringDate } from 'helpers/date';

export const adminLogsApi = createApi({
  reducerPath: 'adminLogsApi',
  baseQuery: createBaseQuery('admin_logs'),
  endpoints: builder => ({
    getAdminLogs: builder.query({
      query: params => `?${toQueryParams(params)}`,
    }),
    downloadAdminLogs: builder.query({
      queryFn: async ({ queryParams }, api, extraOptions, baseQuery) => {
        const { data: file } = await baseQuery({
          url: `/download?${toQueryParams(queryParams)}`,
          responseHandler: async response => {
            const blob = await response.blob();
            return blob;
          },
          cache: 'no-cache',
        });
        saveAs(file, `${stringDate()}_admin_logs`);
        return { data: null };
      },
    }),
  }),
});

export const { useLazyGetAdminLogsQuery, useLazyDownloadAdminLogsQuery } = adminLogsApi;
